var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowGraph = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  preserveAspectRatio: "none",
  viewBox: "0 0 342 153"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#183690",
  strokeDasharray: "2 5",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M4 149C84 45 185 18 330 8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#183690",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m314 0 16 8-12 12"
})));
export default SvgArrowGraph;